import { Heading, Modal, Warning, theme } from '@lmc/ui-kit'
import { ActionModalProps } from '..'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import styled from 'styled-components'
import ModalDescription from '../components/ModalDescription'
import CommentSection, { ITEM_NAME } from '../components/CommentSection'
import { Task } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { showToast } from 'common/utils'
import { Form } from 'antd'
import { generalConstants } from 'locale/general'
import TrashcanIcon from '@lmc/ui-kit/src/general/Icon/customShapes/Trashcan'

const DeleteModal = ({
  task,
  isModalVisible,
  setIsModalVisible,
  onSuccess,
}: ActionModalProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)
  const [form] = Form.useForm<{ comment?: string }>()

  const mutationFunction = (body: {
    comment?: string
  }): Promise<{
    result: Task
  }> =>
    postJSON({
      method: 'DELETE',
      url: `list/tasks/${task.id}`,
      json: { note: body.comment },
    })
  const { mutateAsync, isLoading } = useMutation(mutationFunction, {
    onSuccess: () => {
      showToast({ title: t(toDosConstants.DELETED) })
      setIsModalVisible(false)
      onSuccess?.()
    },
  })

  const handleDelete = (formValues: { comment?: string }) => {
    mutateAsync(formValues)
  }

  return (
    <Modal
      closeButton
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      classicPadding
      closeOnConfirm={false}
      width580px
      onConfirm={form.submit}
      onCancel={() => ''}
      localisation={{
        confirmText: t(toDosConstants.DELETE_SHORT),
        cancelText: t(toDosConstants.CANCEL),
      }}
      confirmButtonProps={{ variant: 'danger', isLoading, icon: TrashcanIcon }}
    >
      <TitleContainer>
        <Warning size={24} color={theme.color.status.danger} />
        <Title level={3}>{t(toDosConstants.DELETE)}</Title>
      </TitleContainer>
      <Divider />
      <ModalDescription text={t(toDosConstants.DELETE_DESCRIPTION)} />
      <Form onFinish={handleDelete} form={form}>
        <Form.Item
          rules={[
            {
              required: true,
              message: t(generalConstants.REQUIRED_MESSAGE, {
                ns: NAMESPACE.GENERAL,
              }),
            },
          ]}
          name={ITEM_NAME}
        >
          <CommentSection required />
        </Form.Item>
      </Form>
      <Divider />
    </Modal>
  )
}
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`
const Title = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

export default DeleteModal
